"use client";

import { NextIntlClientProvider, IntlErrorCode } from "next-intl";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ErrorBoundaryOverlay } from "@/components/custom/error-boundary-overlay";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 3000, // 3s
      refetchOnWindowFocus: false,
    },
  },
});

export default function Providers({
  locale,
  messages,
  children,
}: Readonly<{
  locale: string;
  messages: Record<string, object> | null;
  children: React.ReactNode;
}>) {
  return (
    <NextIntlClientProvider
      locale={locale}
      messages={messages}
      timeZone="Asia/Ho_Chi_Minh"
      // dev(Turbopack)에서 메시지 모듈이 늦게 로드되면 일시적으로 MISSING_MESSAGE가
      // 발생해 콘솔 에러 + 원시 키("mediaProduct.summary.pendingLinkStatusTitle")가
      // 노출되고 재컴파일(약 1분) 후 정상화된다. 누락 메시지는 콘솔 노이즈를 억제하고
      // 원시 키 대신 빈 문자열로 폴백한다(로드되면 정상 라벨 표시).
      onError={(error) => {
        if (error.code === IntlErrorCode.MISSING_MESSAGE) return;
        console.error(error);
      }}
      getMessageFallback={() => ""}
    >
      <ErrorBoundaryOverlay>
        <QueryClientProvider client={queryClient}>
          {children}
        </QueryClientProvider>
      </ErrorBoundaryOverlay>
    </NextIntlClientProvider>
  );
}
